<template>
    <div class="psp_logo">
        <img src="/assets/media/psp/mellat.png" width="45" height="55">
    </div>
</template>

<script>
export default {}
</script>

<style>
</style>